"use strict";
/*
* Types.ts
*
* Copyright (c) Microsoft Corporation. All rights reserved.
* Licensed under the MIT license.
*
* Type definitions to support the plugin.
*/
Object.defineProperty(exports, "__esModule", { value: true });



//////////////////
// WEBPACK FOOTER
// ./~/reactxp-video/dist/common/Types.js
// module id = 741
// module chunks = 0